import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { AppCache } from '@rd-web-markets/shared/dist/util/AppCache';

export const translationsService = {
  all: async (locale, otherParams = '') => {
    const cache = AppCache.getCache('translations')

    if (!otherParams.length && cache[locale]) {
      return cache[locale]
    }

    const res = await fetch(`/api/translations?locale=${locale}&${otherParams}`, request.get);

    cache[locale] = res.translations

    if (!otherParams.length) {
      return cache[locale]
    }else {
      return res
    }
  },
  create(translation) { 
    return fetch('/api/translations/', {
      ...request.post,
      body: JSON.stringify({ translation }),
    });
  },
  update(translation) { 
    return fetch(`/api/translations/${translation.id}`, {
      ...request.put,
      body: JSON.stringify({ translation }),
    });
  },
  delete(translation_id) {
    return fetch(`/api/translations/${translation_id}`, {
      ...request.delete,
    });
  },
};
